module.exports = __webpack_public_path__ + "img/whatsapp-dark.0336cb27.svg";